import { ThemeEvents } from '@theme/events';
import { sectionRenderer } from '@theme/section-renderer';

function getSectionIdFromElement(element) {
  const sectionEl = element.closest('.shopify-section');
  if (!sectionEl || !sectionEl.id) return null;
  return sectionEl.id.replace(/^shopify-section-/, '');
}

function handleCartUpdate() {
  const candidates = document.querySelectorAll('[data-reload-on-cart-update="frequently-bought"]');
  for (const el of candidates) {
    const sectionId = getSectionIdFromElement(el);
    if (sectionId) sectionRenderer.renderSection(sectionId, { cache: false });
  }
}

document.addEventListener(ThemeEvents.cartUpdate, handleCartUpdate);
document.addEventListener(ThemeEvents.discountUpdate, handleCartUpdate);
